import React from 'react'
import { ResponsiveTableRow } from '@fs/zion-ui'
import MetadataCell from './MetadataCell'
import OldChangesCell from './OldChangesCell'
import NewChangesCell from './NewChangesCell'

function addAssociationLink(personChange, value, personChangesState) {
  const relationshipIdRow = personChange.rows.find((idRow) => idRow.key === 'RELATIONSHIP_ID')
  personChangesState.idsMetadata = {
    ...personChangesState.idsMetadata,
    [relationshipIdRow?.[value]]: {
      type: 'ASSOCIATION',
      id: relationshipIdRow?.[value],
    },
  }
}

function addAssociationInfo(personChange, personChangesState) {
  let isOldValue = null
  let isNewValue = null
  personChange.rows.forEach((row) => {
    if (row.key === 'RELATIONSHIP_TYPE') {
      if (row.oldValue === 'Association') {
        isOldValue = true
        addAssociationLink(personChange, 'oldValue', personChangesState)
      }
      if (row.newValue === 'Association') {
        isNewValue = true
        addAssociationLink(personChange, 'newValue', personChangesState)
      }
    }
  })
  if (
    personChange?.rawPersonChange?.journalEvent?.associationType &&
    !personChange.rows.find((row) => row.key === 'Association Type')
  ) {
    personChange.rows.push({
      key: 'Association Type',
      oldValue: isOldValue ? personChange.rawPersonChange.journalEvent.associationType : null,
      newValue: isNewValue ? personChange.rawPersonChange.journalEvent.associationType : null,
    })
  }
}

export default function PersonChangeRow({
  personChange,
  personChangeGroup,
  personChangesState,
  personChangesDispatch,
}) {
  addAssociationInfo(personChange, personChangesState)
  const changeType = personChange.rows.find((row) => row.key === 'TYPE')
  const newChangeMessage = personChange.rows.find((row) => row.key === 'CHANGE_MESSAGE')?.newValue
  const oldChangeMessage = personChange.rows.find((row) => row.key === 'CHANGE_MESSAGE')?.oldValue
  const attributionMessage = personChange.metadata.attribution.changeMessage
  return (
    <ResponsiveTableRow
      selected={personChange.metadata.shouldHighlight}
      noBottomDivider={personChange.metadata.noBottomDivider}
      id={personChange.metadata.changeId}
      data-testid={`row-${personChange.metadata.changeId}`}
      column1={
        <MetadataCell
          metadata={personChange.metadata}
          idsMetadata={personChangesState.idsMetadata}
          displayChangeMessage={
            attributionMessage && attributionMessage !== newChangeMessage && attributionMessage !== oldChangeMessage
          }
        />
      }
      column2={
        <OldChangesCell
          rows={personChange.rows}
          idsMetadata={personChangesState.idsMetadata}
          changeType={changeType?.oldValue}
        />
      }
      column3={
        <NewChangesCell
          rows={personChange.rows}
          idsMetadata={personChangesState.idsMetadata}
          metadata={personChange.metadata}
          personChangesDispatch={personChangesDispatch}
          personChangeGroup={personChangeGroup}
          changeType={changeType?.newValue}
        />
      }
    />
  )
}
